export const ORIGINAL_DESTINATION_URL = "ORIGINAL_DESTINATION_URL";
//# sourceMappingURL=constants.js.map